/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var table_containers = document.querySelectorAll('.table-container');
  if(table_containers) {
    table_containers.forEach((table_container) => {
      check_table_overflow(table_container);

      window.addEventListener('resize', () => {
        check_table_overflow(table_container);
      });
    });
  }

  function check_table_overflow(table_container) {
    if(table_container.scrollWidth > table_container.offsetWidth) {
      table_container.classList.add('overflow');
    } else {
      table_container.classList.remove('overflow');
    }
  }
}());